import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Radio, Alert, Table, Divider, Button } from "antd";
import {
  req_single_tqa_reviewCheck,
  req_single_list_tqa_reviewOpinion,
  req_doc_tqa_review,
} from "../../api";
import { API_BASE } from "../../utils/contrains";

class ReviewSchoolBrowseModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    worker: PropTypes.object.isRequired,
  };

  state = {
    questions: [
      "一、院及系所依據基本素養及核心能力訂定學生學習成效檢核方式及落實情形。",
      "二、院及系所能依據評量結果修訂課程內容。",
      "三、院及系所提升學生實務能力之具體措施。",
      "四、院及系所符合完整之發展與回饋機制。",
      "五、其他有關增進學生學習意願及提升學習成效之具體做法。",
    ],
    options: [
      { label: "非常符合", value: "非常符合" },
      { label: "符合", value: "符合" },
      { label: "普通", value: "普通" },
      { label: "不符合", value: "不符合" },
      { label: "非常不符合", value: "非常不符合" },
    ],
    Checkdata: {},
    columns: [
      {
        title: "頁數",
        dataIndex: "TagCode",
        key: "TagCode",
        render: (text) => <>{text}</>,
      },
      {
        title: "檢核意見",
        dataIndex: "ContentDescription",
        key: "ContentDescription",
      },
    ],
    OpinionData: [],
  };

  UNSAFE_componentWillMount() {
    this.init();
  }

  api_single_checkitem = async () => {
    const { WorkTypeCode, WorkManualVersion } = this.props.worker;
    const { token, userCode } = this.props.user;

    const result = await req_single_tqa_reviewCheck(
      WorkManualVersion,
      userCode,
      WorkTypeCode,
      token
    );
    if (result) {
      this.setState({ Checkdata: result });
    } else {
      this.setState({ Checkdata: null });
    }
  };

  api_single_opinionitem = async () => {
    const { WorkManualVersion, WorkTypeCode } = this.props.worker;
    const { token, userCode } = this.props.user;

    const result = await req_single_list_tqa_reviewOpinion(
      WorkManualVersion,
      userCode,
      WorkTypeCode,
      token
    );
    if (result.total > 0) {
      this.setState({ OpinionData: result.data });
      //console.log("OpinionData:", result);
    } else {
      this.setState({ OpinionData: [] });
    }
  };

  api_downloadfile_items = async () => {
    const { AcademicYear, WorkManualVersion, DepartmentName } =
      this.props.worker;

    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_doc_tqa_review(
      AcademicYear,
      WorkManualVersion,
      userCode,
      DepartmentName,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };
  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    console.log(this.props.worker);

    this.api_single_checkitem();
    this.api_single_opinionitem();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  render() {
    const { questions, options, Checkdata, columns, OpinionData } = this.state;
    const checkview = Checkdata ? (
      <>
        <Alert message={questions[0]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueA} />
        <p></p>
        <Alert message={questions[1]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueB} />
        <p></p>
        <Alert message={questions[2]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueC} />
        <p></p>
        <Alert message={questions[3]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueD} />
        <p></p>
        <Alert message={questions[4]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueE} />
      </>
    ) : null;

    const opinionview = OpinionData ? (
      <Table columns={columns} dataSource={OpinionData} pagination={false} />
    ) : (
      <>無任何審查意見</>
    );

    const title = (
      <>
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "4px" }}
        >
          <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
        </Button>
      </>
    );

    return (
      <Card title={title}>
        {checkview}
        <Divider />
        {opinionview}
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewSchoolBrowseModal);
